/**
 * @generated SignedSource<<e7e2af22ebbf30545dce8c2e6fd0b59b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditTextPageFromTextWithPagesElementInput = {
  clientMutationId?: string | null;
  elementId: string;
  newInternalTitle: string;
  newText: string;
  pageId: string;
};
export type useTextWithPagesElementPageMutations_EditTextPageMutation$variables = {
  input: EditTextPageFromTextWithPagesElementInput;
};
export type useTextWithPagesElementPageMutations_EditTextPageMutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly editTextPageFromTextWithPagesElement: {
        readonly textWithPagesElement: {
          readonly " $fragmentSpreads": FragmentRefs<"textWithPagesElementForm_TextWithPagesElementFragment">;
        };
      } | null;
    };
  };
};
export type useTextWithPagesElementPageMutations_EditTextPageMutation = {
  response: useTextWithPagesElementPageMutations_EditTextPageMutation$data;
  variables: useTextWithPagesElementPageMutations_EditTextPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTextWithPagesElementPageMutations_EditTextPageMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditTextPageFromTextWithPagesElementPayload",
                "kind": "LinkedField",
                "name": "editTextPageFromTextWithPagesElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextWithPagesElement",
                    "kind": "LinkedField",
                    "name": "textWithPagesElement",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "textWithPagesElementForm_TextWithPagesElementFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTextWithPagesElementPageMutations_EditTextPageMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditTextPageFromTextWithPagesElementPayload",
                "kind": "LinkedField",
                "name": "editTextPageFromTextWithPagesElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextWithPagesElement",
                    "kind": "LinkedField",
                    "name": "textWithPagesElement",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "task",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TextWithPagesPage",
                        "kind": "LinkedField",
                        "name": "pages",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "internalTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "kind",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TextWithPagesTextPageData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "image",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TextWithPagesImagePageData",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16f760c9110df1d2350688bc6f7c21e3",
    "id": null,
    "metadata": {},
    "name": "useTextWithPagesElementPageMutations_EditTextPageMutation",
    "operationKind": "mutation",
    "text": "mutation useTextWithPagesElementPageMutations_EditTextPageMutation(\n  $input: EditTextPageFromTextWithPagesElementInput!\n) {\n  Admin {\n    ElearningV2 {\n      editTextPageFromTextWithPagesElement(input: $input) {\n        textWithPagesElement {\n          ...textWithPagesElementForm_TextWithPagesElementFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment textWithPagesElementForm_TextWithPagesElementFragment on TextWithPagesElement {\n  id\n  title\n  task\n  ...textWithPagesElementPagesEditor_PagesFragment\n}\n\nfragment textWithPagesElementPageFormDialog_PageFragment on TextWithPagesPage {\n  internalTitle\n  ...textWithPagesElementPageForm_TextWithPagesPageFragment\n}\n\nfragment textWithPagesElementPageForm_TextWithPagesPageFragment on TextWithPagesPage {\n  internalTitle\n  data {\n    __typename\n    kind\n    ... on TextWithPagesTextPageData {\n      text\n    }\n    ... on TextWithPagesImagePageData {\n      image {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment textWithPagesElementPagesEditor_PagesFragment on TextWithPagesElement {\n  id\n  pages {\n    id\n    internalTitle\n    data {\n      __typename\n      kind\n    }\n    ...textWithPagesElementPageFormDialog_PageFragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "9cb3dcc2bd0a9b6d47696f6d3dac0608";

export default node;
